// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FOOTER_DOWNLOAD_ON_APP_STORE = "Stiahni z App Store";
export const INSTALL_PROMPT_DESCRIPTION = "Stiahni si nov\u00fa kon\u00edkovsk\u00fa appku do mobilu";
export const INSTALL_PROMPT_DOWNLOAD_APP = "Stiahni aplik\u00e1ciu";
